import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../tooltip'
import { cn } from '@nwwp/ui-shadcn/lib/utils'

type TooltipIconProps = {
  title: string
  'aria-label'?: string
  className?: string
}

/** Inline “?” help control for calculator field labels. */
function TooltipIcon({ title, 'aria-label': ariaLabel = 'More information', className }: TooltipIconProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            aria-label={ariaLabel}
            className={cn(
              'ml-1 inline-flex size-[18px] cursor-help items-center justify-center rounded-full bg-smoke text-body-xs font-bold text-neutral-dark',
              className
            )}
          >
            ?
          </span>
        </TooltipTrigger>
        <TooltipContent className="text-subtitle">{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export { TooltipIcon }
export type { TooltipIconProps }
